<div style="padding: 2rem">
  <h1>{{ "security_and_compliance" | translation }}</h1>
  <p>{{ "security_statement" | translation }}.</p>
  <h2>{{ "documents" | translation }}</h2>
  <div *ngFor="let document of documents" class="document">
    <h6>{{ document.titleTranslationKey || document.title | translation }}</h6>
    <p
      *ngIf="document?.descriptionTranslationKey || document?.description"
      [innerHTML]="
        document?.descriptionTranslationKey || document?.description
          | translation
          | translationFromString
          | safeHtml
      "
    ></p>
    <ng-container *ngIf="document?.descriptions?.length">
      <ng-container *ngFor="let innerDescription of document?.descriptions">
        <p *ngIf="innerDescription.type == 'text'">
          {{
            innerDescription.descriptionTranslationKey || innerDescription.text
              | translation
          }}
        </p>
        <a
          target="_blank"
          [href]="innerDescription.link"
          *ngIf="innerDescription.type == 'link'"
        >
          {{ innerDescription.text }}
        </a>
      </ng-container>
    </ng-container>
    <a
      [href]="document.link | safe"
      rel="noopener noreferrer"
      target="_blank"
      >{{ document.linkText }}</a
    >
  </div>
  <h2>{{ "questions_additional" | translation }}</h2>
  <p>
    <span style="padding-right: 5px;">{{ "questions_contact_us" | translation }}</span
    ><a href="https://k16solutions.com/security/" target="_blank"
      >k16solutions.com/security/</a
    >
  </p>
</div>
